import { Article } from '@/components/molecules';

type TermsOfPrivacyProps = {
  scrollable?: boolean;
};

const TermsOfPrivacy = () => {
  return (
    <>
      <p>
        주식회사 핀카(이하 ‘회사’라 함)는 <a href="https://www.law.go.kr/법령/개인정보보호법">개인정보보호법</a>,{' '}
        <a href="https://www.law.go.kr/법령/정보통신망이용촉진및정보보호등에관한법률">정보통신망 이용촉진 및 정보보호 등에 관한 법률</a> 등 관련
        법령상의 개인정보보호 규정을 준수하고, 관련 법령에 의거한 개인정보처리방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.
      </p>
      <p>
        본 개인정보처리방침은 회사가 운영하는 “핀카 비즈센터” 서비스(이하 ‘비즈센터’라 합니다) 등 관련 제반서비스에 적용되며 다음과 같은 내용을 담고
        있습니다. 이 개인정보처리방침에서 사용하는 용어의 의미는 관련 법령 및 회사의 이용약관에서 정한 바에 따르며, 그 밖의 사항은 일반적인 상관례에
        따릅니다.
      </p>
      <Article title="제 1조 (수집하는 개인정보의 항목)">
        <p>
          회사는 회원이 입력한 정보를 기반으로 회원가입, ‘비즈센터’ 서비스의 제공, 원활한 고객상담 등을 위하여 필요한 최소한의 개인정보를 수집하고
          있습니다.
        </p>
        <p>회원가입 시점에 비즈센터가 이용자로부터 수집하는 개인정보는 아래와 같습니다.</p>
        <ol>
          <li>회원가입 시점</li>
          <ul>
            <li>필수 : 회원의 아이디(이메일), 비밀번호, 이름, 휴대폰번호</li>
          </ul>
          <li>서비스 이용과정</li>
          <ul>
            <li>‘비즈센터’ 내의 개별 서비스 이용 과정에서 해당 서비스의 이용자에 한해 추가 개인정보 수집이 발생할 수 있습니다.</li>
            <li>
              추가로 개인정보를 수집할 경우에는 해당 개인정보 수집 시점에서 이용자에게 ‘수집하는 개인정보 항목, 개인정보의 수집 및 이용목적,
              개인정보의 보관기간’에 대해 안내 드리고 동의를 받습니다.
            </li>
            <li>서비스 이용 과정에서 IP 주소, 쿠키, 서비스 이용 기록, 기기정보, 위치정보가 생성되어 수집될 수 있습니다.</li>
          </ul>
        </ol>
        <p>
          구체적으로 1) 서비스 이용 과정에서 이용자에 관한 정보를 정보통신서비스 제공자가 자동화된 방법으로 생성하여 이를 저장(수집)하거나, 2) 이용자
          기기의 고유한 정보를 원래의 값을 확인하지 못 하도록 안전하게 변환한 후에 수집하는 경우를 의미합니다.
        </p>
      </Article>
      <Article title="제 2조 (개인정보의 수집방법)">
        <p>회사는 다음과 같은 방법으로 개인정보를 수집합니다.</p>
        <ol>
          <li>서비스 가입이나 사용 중 이용자의 동의를 통한 수집</li>
          <li>기기 정보, 서비스 이용 기록 등 생성 정보는 서비스 이용과정에서 자동으로 수집</li>
        </ol>
      </Article>
      <Article title="제 3조 (개인정보의 수집 및 이용목적)">
        <p>회사는 개인정보를 다음의 목적을 위해 수집∙이용합니다.</p>
        <ol>
          <li>회원가입 및 서비스 이용 관리</li>
          <ul>
            <li>
              회원 가입 의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스
              부정이용 방지, 만14세 미만 아동 개인정보 수집 시 법정대리인 동의 여부 확인, 서비스 이용 관련 각종 고지·통지, 고충처리, 분쟁 조정을 위한
              기록 보존 등을 목적으로 개인정보를 처리합니다.
            </li>
          </ul>
          <li>민원사무 처리</li>
          <ul>
            <li>민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보 등을 목적으로 개인정보를 처리합니다.</li>
          </ul>
          <li>재화 또는 서비스 제공</li>
          <ul>
            <li>서비스 제공, 콘텐츠 제공, 맞춤 서비스 제공, 본인인증, 연령인증, 요금결제·정산, 채권추심 등을 목적으로 개인정보를 처리합니다.</li>
          </ul>
          <li>마케팅 및 광고에의 활용</li>
          <ul>
            <li>
              신규 서비스(제품) 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 인구통계학적 특성에 따른 서비스 제공 및 광고
              게재, 서비스의 유효성 확인, 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계 등을 목적으로 개인정보를 처리합니다.
            </li>
          </ul>
        </ol>
      </Article>
      <Article title="제 4조 (개인정보 보유 및 이용기간)">
        <p>
          회사는 법령에 따른 개인정보 보유·이용기간 또는 회원으로 부터 개인정보 수집 시에 동의 받은 개인정보 보유·이용기간 내에서 개인정보를
          처리·보유합니다. 회원의 개인정보는 원칙적으로 개인정보의 수집 및 이용 목적이 달성된 후 지체 없이 파기되며 단, 다음의 정보에 대해서는 아래의
          이유로 명시한 기간 동안 보존합니다.
        </p>
        <ol>
          <li>계약 또는 청약철회 등에 관한 기록</li>
          <li>대금결제 및 재화 등의 공급에 관한 기록</li>
          <li>소비자의 불만 또는 분쟁 처리에 관한 기록</li>
          <li>서비스 이용 관련 기록</li>
        </ol>
      </Article>
      <Article title="제 5조 (이용자 및 법정대리인의 권리, 의무 및 행사방법)">
        <p>이용자 및 법정대리인은 언제든지 자신의 개인정보를 열람, 공개 및 비공개 처리하거나 수정할 수 있으며, 삭제 및 파기를 요청할 수 있습니다.</p>
        <ol>
          <li>개인정보의 열람 및 수정 요청</li>
          <ul>
            <li>
              이용자 및 법정대리인은 언제든지 등록되어 있는 본인 또는 만 14세미만 아동의 개인정보를 조회, 수정할 수 있습니다. 회원 또는 법정대리인은
              당해 개인정보의 조회, 수정을 위하여 비즈센터 서비스에 사용자 메뉴를 클릭하여 계정 등 등록된 개인정보를 직접 열람하거나 수정할 수
              있습니다.
            </li>
          </ul>
          <li>개인정보의 삭제(회원탈퇴)</li>
          <ul>
            <li>
              이용자 및 만 14세 미만 아동의 법정대리인이 회원탈퇴를 원하는 경우, 웹사이트 또는 모바일 애플리케이션으로 로그인한 후 &quot;비즈센터 &gt;
              사용자정보 수정 &gt; 회원탈퇴&quot;를 통해 직접 탈퇴할 수 있습니다. 만일, 직접 탈퇴가 어려운 경우 고객센터로 서면, 전화 또는 이메일로
              연락하시면 지체없이 조치를 취하겠습니다.
            </li>
          </ul>
        </ol>
      </Article>
      <Article title="제 6조 (개인정보의 제3자 제공)">
        <ul>
          <li>회사는 회원의 개인정보를 사전 동의 없이 제3자에게 제공하지 않습니다.</li>
          <li>
            회원의 개인정보를 제공하거나 공유하는 경우에는 회원에게 제공받거나 공유하는 자가 누구이며, 제공 또는 공유되는 개인정보 항목이 무엇인지,
            개인정보를 제공하거나 공유하는 목적이 무엇인지, 보유 및 이용기간 등에 대해 개별적으로 사이트, 전자우편 또는 서면, 신청서 등을 통해 고지한
            후 이에 대하여 별도 동의를 구합니다.
          </li>
          <li>다만 관련 법령에서 달리 정하는 경우에는 회원의 동의 없이 개인정보를 제공하는 것이 가능합니다.</li>
        </ul>
      </Article>
      <Article title="제7조 개인정보처리의 위탁에 관한 사항">
        <p>
          회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다. 회사는 위탁계약 체결시 관련 법령을 준수하고,
          수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다. 위탁 업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보처리방침을
          통해 공개하도록 하겠습니다.
        </p>
      </Article>
      <Article title="제8조 개인정보의 파기 절차 및 방법">
        <p>개인정보 파기절차 및 방법은 다음과 같습니다.</p>
        <ol>
          <li>파기절차</li>
          <ul>
            <li>회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다.</li>
            <li>단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우, 일정 기간 별도로 보관한 후 파기합니다.</li>
            <li>이 경우 별도로 보관된 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.</li>
          </ul>
          <li>파기방법</li>
          <ul>
            <li>
              종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기하고, 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적
              방법을 사용하여 삭제합니다.
            </li>
          </ul>
        </ol>
      </Article>
      <Article title="제9조 개인정보 자동수집장치의 설치/운영 및 그 거부에 관한 사항">
        <p>회사는 이용자의 정보를 수시로 저장하고 찾아내는 &quot;쿠키(cookie)&quot; 등 개인정보를 자동으로 수집하는 장치를 설치·운용합니다.</p>
        <p>
          쿠키란 회사의 웹사이트를 운영하는데 이용되는 서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 이용자의 컴퓨터 하드디스크에
          저장됩니다. 회사는 회원과 비회원의 접속 빈도나 방문 시간 등을 분석, 방문 회수 파악 등을 통한 개인 맞춤 서비스를 제공하기 위하여 쿠키 등을
          사용합니다.
        </p>
        <p>
          이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 사용하시는 웹브라우저의 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다
          확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다. 단, 쿠키의 저장을 거부할 경우에는 로그인이 필요한 일부 서비스는 이용할 수
          없습니다.
        </p>
        <p>– 설정방법 예(인터넷 익스플로어의 경우) : 웹 브라우저 상단의 도구 &gt; 인터넷 옵션 &gt; 개인정보</p>
      </Article>
      <Article title="제10조 개인정보 보호책임자에 관한 사항">
        회사는 개인정보를 보호하고 개인정보에 관련된 불만을 처리하는 등 개인정보의 처리에 관한 업무를 총괄해서 책임질 개인정보 보호책임자를 다음과
        같이 지정하고 있습니다.
        <ul>
          <li>개인정보 보호책임자: 이상협</li>
          <li>담당부서: Service 지원본부</li>
          <li>이메일: support@pincar.co.kr</li>
        </ul>
      </Article>
      <Article title="제11조 개인정보 처리방침의 변경에 관한 사항">
        이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 가능한 변경사항의 시행 7일 전에
        홈페이지 또는 이메일 등을 통해 사전 공지하고 사전 공지가 곤란한 경우 지체없이 공지합니다.
      </Article>
    </>
  );
};

TermsOfPrivacy.defaultProps = {
  // TODO
};

export default TermsOfPrivacy;
